import React, { useCallback, memo } from 'react';

import BreadcrumbLayout from 'Components/BreadcrumbLayout';
import Breadcrumb from 'Components/Breadcrumb';
import TabContent from 'Components/TabContent';
import TeacherStudents from 'Containers/TeacherStudents';
import { withAuth } from 'Libs/Auth';

const BreadcrumbComponent = memo(function BreadcrumbComponent() {
  const items = [
    {
      key: 'module',
      title: 'Module',
      path: '/teacher/modules',
    },
  ];
  return <Breadcrumb items={items} variant={'dark'} />;
});

const TeacherModulePage = props => {
  const {
    auth: {
      myProfile: { id: userId },
    },
  } = props;
  return (
    <BreadcrumbLayout
      breadcrumbComponent={useCallback(
        () => (
          <BreadcrumbComponent />
        ),
        [],
      )}
    >
      <TabContent content={<TeacherStudents userId={userId} path="modules" />} />
    </BreadcrumbLayout>
  );
};

export default memo(withAuth(TeacherModulePage));
